"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable: no-unused-expression
const helpers_1 = require("./helpers");
const setEvent = (el, event, listener, options) => {
    try {
        el.addEventListener
            ? el.addEventListener(event, listener, !!options)
            // tslint:disable-next-line: no-unused-expression
            : el.attachEvent && el.attachEvent('on' + event, listener);
    }
    catch (e) {
        helpers_1.default.trace(27);
    }
};
const encodeValue = (a) => {
    if (encodeURIComponent instanceof Function) {
        return encodeURIComponent(a);
    }
    helpers_1.default.trace(28);
    return a;
};
const getNormalizedHost = (doc) => {
    const host = '' + doc.location.hostname;
    return 0 === host.indexOf('www.') ? host.substring(4) : host;
};
const countPathSegments = (path) => {
    path = normalizePath(path);
    return '/' === path ? 1 : path.split('/').length;
};
const normalizePath = (path) => {
    if (!path) {
        return '/';
    }
    1 < path.length && path.lastIndexOf('/') === path.length - 1 && (path = path.substr(0, path.length - 1));
    0 !== path.indexOf('/') && (path = '/' + path);
    return path;
};
// done for mocking purposes
const getWindow = () => {
    return window || {};
};
// done for mocking purposes
const getDocument = () => {
    return window && window.document;
};
exports.default = {
    countPathSegments,
    encodeValue,
    getNormalizedHost,
    normalizePath,
    setEvent,
    getWindow,
    getDocument,
};
